// extracted by mini-css-extract-plugin
module.exports = {"separator":"widget-space--separator--3bNQE","activityList":"widget-space--activityList--33PBV"};